<template>
    <div class="node-properties-inner">
        <select v-model="properties.assetKey">
            <option value="red">Red</option>
            <option value="green">Green</option>
            <option value="blue">Blue</option>
            <option value="yellow">Yellow</option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        properties: { type: Object, required: true }
    }
}
</script>
